import type { ReactNode } from "react";

interface StatusMessageProps {
    children: ReactNode;
}

// Centered gray text for loading, error and empty states
const StatusMessage = ({ children }: StatusMessageProps) => {
    return (
        <div className="w-full flex justify-center items-center py-20">
            <span className="text-gray-500 text-lg">{children}</span>
        </div>
    );
};

export default StatusMessage;